import React, { Fragment } from 'react';
import { on_change } from "../../../../shared-functions/on-change";
import { Option } from 'rc-select';
import { Descriptions, Select, Form, Row, Col, Input, Radio, Button } from 'antd';
import { CheckCircleFilled, CloseCircleFilled, ExclamationCircleFilled, LoadingOutlined } from '@ant-design/icons';
import { table_list_type } from '../../contexts/table-list';
import { FormattedMessage } from 'react-intl';
import { http_request_new, response_type } from '../../../../http-worker/http-func';
import Cookies from "universal-cookie";
// import { user_subscription } from '../../../../worker/function/interfaces';
import { storage_settings_post_process } from "./storage-settings";
import { operation_type } from '../../../../components/new-table-list/interface';
import { backup_management_fields_type, modal_type } from '../backup/backup.operation';
import custom_warning from '../../../../shared-functions/custom-warning';
import { IntlFormatters } from '@formatjs/intl';
import { check_existed } from "../backup/backup";

export const storage_settings_operation = (): operation_type[] => {

    const operation_status = (modal_title: string, action: 0 | 1 | 2 | 3 | undefined, caption: string) => ({
        modal_title,
        action,
        caption,
    });
    const storage_settings_refresh_url = (props: any) => {
        const { subscription_id, storage_type } = props;
        return `/backup/dbStorages${subscription_id === "all" && !storage_type ? '' :
            `?${subscription_id === "all" ? `storageDeviceType=${storage_type}` :
                !storage_type ? `subscriptionId=${subscription_id}` : `subscriptionId=${subscription_id}&storageDeviceType=${storage_type}`
            }`}`
    }

    const storage_ok = ({ props, form }: modal_type) => {

        const { action, item_selected, selected_subscriptions, lang } = props;
        const formatMessage = props?.intl?.formatMessage as IntlFormatters['formatMessage'];
        const { storage_name, storage_type, subscription_name, description, version, remote_path } = form?.getFieldsValue() as backup_management_fields_type;
        const add_storage = {
            dbStorageName: storage_name,
            subscriptionId: selected_subscriptions === "all" ? subscription_name : selected_subscriptions,
            storageDevice: {
                type: storage_type,
                remotepath: remote_path,
                version: version
            },
            description: description
        };

        let data;
        if (add_storage) {
            switch (action) {
                case 0:
                    data = {
                        key: "storage_backup",
                        url: '/backup/dbStorages',
                        body: add_storage
                    };
                    break;
                case 1:
                    data = {
                        key: "storage_settings",
                        url: `/backup/dbStorages/${item_selected?.db_storage.id}`,
                        body: add_storage,
                        patch: 1,
                        content_type: "application/merge-patch+json",
                        custom_warning: (e: any) => {
                            custom_warning({
                                response_new: e as response_type,
                                key: "storage_settings",
                                formatMessage,
                                success_message: `${formatMessage({ id: 'storage_backup' })}${lang === "en-US" ? " " : ""}${formatMessage({ id: 'updated' })}${lang === "en-US" ? " " : ""}${formatMessage({ id: 'successfully' })}`,
                                error_message: `${formatMessage({ id: 'storage_backup' })}${lang === "en-US" ? " " : ""}${formatMessage({ id: 'updated' })}${lang === "en-US" ? " " : ""}${formatMessage({ id: 'error' })}`
                            })
                        }
                    };
                    break;
                default:
                    break;
            }
            return data
        } else return { url: "" }
    }

    const storage_settings_msg = ({ props, formatMessage, form, set_disabled, disabled }: modal_type) => {

        const cookies = new Cookies();
        const cookie_lang = cookies.get("lang");
        const { version } = form?.getFieldsValue() as backup_management_fields_type;
        const { lang, items, action, connection_status, set_connection_status, user_info, selected_subscriptions, format_subscriptions, storage_type_list, action_id, item_selected, connect_loading, set_connect_loading } = props;
        const signature_version_option = [
            { name: "v2", value: "v2" },
            { name: "v4", value: "v4" }
        ];
        const NFS_version_option = [
            { name: "3", value: "3" },
            { name: "4.0", value: "4.0" },
            { name: "4.1", value: "4.1" },
            { name: "4.2", value: "4.2" }
        ];

        let initial_data: Object = {};
        initial_data = action_id === 1 ? {
            storage_name: item_selected?.storage_name,
            storage_type: item_selected?.storage_type,
            region: item_selected?.region,
            access_key: item_selected?.access_key,
            secret_key: item_selected?.secret_key,
            description: item_selected?.description,
            ssl: item_selected?.ssl,
            endpoint: item_selected?.endpoint,
            signature_version: item_selected?.signature_version,
            version: item_selected?.storage_device.version,
            // NFS_service: item_selected?.NFS_service,
            remote_path: item_selected?.storage_device.remote_path,
            subscription_name: item_selected?.subscription_name
        } : {
                subscription_name: selected_subscriptions === "all" ? undefined : selected_subscriptions,
                storage_type: "nfs",
                ssl: 1,
                signature_version: signature_version_option[0].name,
                version: NFS_version_option[0].name
            };
        const storage_type = form?.getFieldValue("storage_type") ? form?.getFieldValue("storage_type") : "nfs";
        let storage_fields: any[] = [];

        switch (storage_type.toLowerCase()) {
            case "amazon s3":
                storage_fields = [
                    { key: "subscription_name", name: "subscription_name", type: "subscription", is_required: true },
                    { key: "storage_name", name: "storage_name", type: "input", is_required: true },
                    { key: "storage_type", name: "storage_type", type: "select", value: storage_type_list, is_required: true },
                    { key: "region", name: "region", type: "input", is_required: true },
                    { key: "access_key", name: "access_key", type: "input", is_required: true },
                    { key: "secret_key", name: "secret_key", type: "input", is_required: true },
                    { key: "description", name: "description", type: "input" }
                ];
                break;
            case "s3 compatible":
                storage_fields = [
                    { key: "subscription_name", name: "subscription_name", type: "subscription", is_required: true },
                    { key: "storage_name", name: "storage_name", type: "input", is_required: true },
                    { key: "storage_type", name: "storage_type", type: "select", value: storage_type_list, is_required: true },
                    { key: "ssl", name: "ssl", type: "radio", is_required: true },
                    { key: "signature_version", name: "signature_version", type: "select", value: signature_version_option, is_required: true },
                    { key: "endpoint", name: "endpoint", type: "input", is_required: true },
                    { key: "access_key", name: "access_key", type: "input", is_required: true },
                    { key: "secret_key", name: "secret_key", type: "input", is_required: true },
                    { key: "description", name: "description", type: "input" }
                ];
                break;
            case "nfs":
                storage_fields = [
                    { key: "subscription_name", name: "subscription_name", type: "subscription", is_required: true },
                    { key: "storage_name", name: "storage_name", type: "input", is_required: true },
                    { key: "storage_type", name: "storage_type", type: "select", value: storage_type_list, is_required: true },
                    { key: "version", name: "version", type: "select", value: NFS_version_option, is_required: true },
                    // { key: "NFS_service", name: "NFS_service", type: "input", is_required: true },
                    { key: "remote_path", name: "remote_path", type: "input", is_required: true },
                    { key: "description", name: "description", type: "input" }
                ];
                break;
            default:
                break;
        }

        return action_id !== 3 ?
            <Form
                labelCol={{ span: 7 }}
                wrapperCol={{ span: 17 }}
                className="px-20 pr-30 backup-schedule"
                labelAlign='left'
                form={form}
                initialValues={initial_data}
            >
                {!!storage_fields.length && storage_fields.map(({ key, name, type, value, is_required }, index) => {
                    let item_jsx: JSX.Element | undefined = undefined;
                    switch (type) {
                        case "input":
                            item_jsx = <Form.Item label={formatMessage({ id: name })} key={key} name={name}
                                rules={name === "storage_name" ?
                                    [{ required: is_required, message: formatMessage({ id: "this_is_required" }) },
                                    { pattern: /^[a-zA-Z0-9]+([a-zA-Z0-9.-]{0,}[a-zA-Z0-9]+)?$/, message: formatMessage({ id: "backup_regexp_2" }) },
                                    { type: "string", max: 63, message: formatMessage({ id: "max_name_length" }, { length: 63 }) },
                                    check_existed(formatMessage, items, action, item_selected)] :
                                    name === "remote_path" ?
                                        [{ required: is_required, message: formatMessage({ id: "this_is_required" }) },
                                        { type: "string", max: 253, message: formatMessage({ id: "max_name_length" }, { length: 253 }) }] :
                                        [{ required: is_required, message: formatMessage({ id: "this_is_required" }) }]}>
                                <Input
                                    style={{ width: '100%' }}
                                    placeholder={formatMessage({ id: "please_input" }, { type: `${formatMessage({ id: name }).toLowerCase()}` })}
                                    onKeyDown={(event: any) => {
                                        if (event.keyCode === 13) event.target.blur();
                                    }}
                                    onChange={(e: any) => {
                                        set_connection_status?.("");
                                        on_change(form, set_disabled);
                                    }}
                                />
                            </Form.Item>;
                            break;
                        case "select":
                            item_jsx = <Form.Item
                                label={formatMessage({ id: name === "version" ? "NFS_version" : name })}
                                key={key} name={name} rules={[{ required: is_required, message: formatMessage({ id: "this_is_required" }) }]}>
                                <Select
                                    showSearch
                                    style={{ width: '100%' }}
                                    onChange={(e: any) => {
                                        // set_tick?.({});
                                        set_connection_status?.("");
                                        action_id === 1 &&
                                            form?.getFieldValue(name) !== (name === "version" ? item_selected?.storage_device.version : item_selected[name]) &&
                                            set_disabled(false);
                                        on_change(form, set_disabled);
                                    }}
                                >
                                    {value?.map((item: any, index: number) => {
                                        return (
                                            <Option value={name === "storage_type" ? item.storage_type : item.name} key={index}>
                                                {item.name}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            </Form.Item>;
                            break;
                        case "radio":
                            item_jsx = <Form.Item label={formatMessage({ id: name })} key={key} name={name} rules={[{ required: is_required, message: formatMessage({ id: "this_is_required" }) }]}>
                                <Radio.Group onChange={(e: any) => { console.log(e.target.value) }}>
                                    <Radio value={1}>True</Radio>
                                    <Radio value={0}>False</Radio>
                                </Radio.Group>
                            </Form.Item>;
                            break;
                        case "subscription":
                            item_jsx = selected_subscriptions === "all" ? <Form.Item label={formatMessage({ id: name })} key={key} name={name} rules={[{ required: is_required, message: formatMessage({ id: "this_is_required" }) }]}>
                                <Select
                                    showSearch
                                    placeholder={formatMessage({ id: "please_select" }, { type: `${formatMessage({ id: "subscription" }).toLowerCase()}` })}
                                    disabled={(format_subscriptions && format_subscriptions.length < 2) || !!action}
                                    optionFilterProp="children"
                                    dropdownRender={(menu) => (
                                        <Fragment>
                                            <div className="ant-select-item ant-select-item-group">With Resources Only</div>
                                            {menu}
                                        </Fragment>
                                    )}
                                    filterOption={(input, option) => (option?.key as string)?.toLocaleLowerCase().includes(input.toLocaleLowerCase())}
                                    style={{ width: '100%' }}
                                    onChange={(e: any) => {
                                        set_connection_status?.("");
                                        action_id === 1 && form?.getFieldValue("subscription_name") !== item_selected?.subscription_name && set_disabled(false);
                                        // subscriptions_change(e, format_subscriptions, set_sso_subscription_selected);
                                        on_change(form, set_disabled);
                                    }}
                                >
                                    {user_info?.ssoRole === "globalAdmin" && <Option disabled key='all' value='all'>
                                        {formatMessage({ id: 'all_subscription' })}
                                    </Option>}
                                    {Array.isArray(format_subscriptions) &&
                                        format_subscriptions.map(({ id, name, company }: any) => (
                                            <Option key={name + company} value={id}>
                                                <Row
                                                    title={
                                                        formatMessage({ id: "subscription_name" }) +
                                                        ": " +
                                                        name +
                                                        "        " +
                                                        formatMessage({ id: "company" }) +
                                                        ": " +
                                                        company
                                                    }
                                                >
                                                    <Col lg={9} md={10} sm={11} xs={12} className="font-w-6 text-ellipsis">
                                                        {name}
                                                    </Col>
                                                    <Col lg={13} md={12} sm={11} xs={10} className="ml-10 text-ellipsis">
                                                        {company}
                                                    </Col>
                                                </Row>
                                            </Option>
                                        ))}
                                </Select>
                            </Form.Item> : undefined;
                            break;
                        default:
                            break;
                    }
                    return item_jsx
                })}

                <Form.Item className="connection-item">
                    <Button
                        type='primary'
                        disabled={action ? undefined : disabled}
                        className="test-connection-btn test-connection mr-20"
                        onClick={async () => {
                            try {
                                // await form?.validateFields();
                                set_connect_loading?.(true);
                                const connection_body = {
                                    storageDevice: {
                                        type: storage_type,
                                        remotepath: form?.getFieldValue("remote_path"),
                                        version: version
                                    }
                                };
                                let result: any = await http_request_new({
                                    key: "test_connection",
                                    props: props,
                                    func: undefined,
                                    url: '/backup/dbStorages/checkz',
                                    method: 2,
                                    body: connection_body,
                                    custom_warning: (response_new: response_type) => {
                                        custom_warning({
                                            response_new: response_new as response_type,
                                            key: "test_connection",
                                            formatMessage,
                                            success_message: `${formatMessage({ id: 'test_connection_text' })}${lang === "en-US" ? " " : ""}${formatMessage({ id: 'successfully' })}${lang === "en-US" ? "!" : "！"}`,
                                            error_message: `${formatMessage({ id: 'test_connection_text' })}${lang === "en-US" ? " " : ""}${formatMessage({ id: 'error' })}${lang === "en-US" ? "!" : "！"}`
                                        })
                                    }
                                });
                                set_connection_status?.(result?.ok ? "success" : "failed");
                                set_connect_loading?.(false);
                            } catch (error) {
                                set_connection_status?.("failed");
                                set_connect_loading?.(false);
                            }
                        }}
                    >
                        {connect_loading ? <LoadingOutlined className="px-20 font-10" /> : formatMessage({ id: "test_connection" })}
                    </Button>
                    <Row
                        align="middle"
                        className={`storage_connection ${connection_status === "success" ? "success_color" : "failed_color"} ${cookie_lang === "en-US" ? "en-position" : "zh-position"}`}>
                        {connection_status === "success" ? <Fragment>
                            <CheckCircleFilled className="connection_success mr-10" />
                            <Col><FormattedMessage id="connection_successful" /></Col>
                        </Fragment> :
                            connection_status === "failed" && <Fragment>
                                <CloseCircleFilled className="connection_success mr-10" />
                                <Col><FormattedMessage id="connection_failed" /></Col>
                            </Fragment>}
                    </Row>
                </Form.Item>
            </Form> :
            <Col className="backup-description mb-20">
                <Descriptions bordered size="small" className="px-20" style={{ width: "100%" }} column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}>
                    {storage_fields?.slice(1, storage_fields.length).map(({ name }) =>
                        <Descriptions.Item
                            labelStyle={{ width: "35%" }}
                            label={<span>{formatMessage({ id: name })}</span>}
                        >
                            {name === "subscription_name" ?
                                <Row>
                                    {format_subscriptions?.filter(item => { return item.id === props?.item_selected?.[name] })?.[0]?.name}
                                    <Col className="ml-10">{format_subscriptions?.filter(item => { return item.id === props?.item_selected?.[name] })?.[0]?.company}</Col>
                                </Row> :
                                (name === "version" || name === "remote_path") ? item_selected?.storage_device[name] :
                                    name === "storage_type" && item_selected?.storage_type === "nfs" ? "NFS" : item_selected?.[name]}
                        </Descriptions.Item>
                    )}
                </Descriptions>
            </Col>
    }

    const delete_storage_msg = ({ props, formatMessage }: modal_type) => {

        const { item_selected, lang } = props;

        return <Col className="px-10 py-10">
            <Row style={{ flexWrap: "nowrap" }}>
                <ExclamationCircleFilled className="warning-icon" />
                <Col>{formatMessage({ id: "delete_backup_restore_msg" }, {
                    type: <Col
                        style={{ display: "contents", wordBreak: "break-all" }}
                    >
                        <span
                            className={`${lang === "en-US" ? "ml-5" : ""}`}>
                            {formatMessage({ id: 'storage_backup' }).toLowerCase()}&nbsp;
                            </span>
                        <span className={`font-w-6 ${lang !== "en-US" ? "mr-5" : ""}`}>
                            {item_selected?.db_storage?.name}
                        </span>
                    </Col>
                })}
                </Col>
            </Row>
        </Col >
    }

    return [
        {
            ...operation_status('add_storage', 0, 'create'),
            width: 580,
            modal_message: storage_settings_msg,
            handle_ok: storage_ok,
            refresh_url: storage_settings_refresh_url,
            refresh_set_state: (props: { set_items: React.Dispatch<React.SetStateAction<table_list_type>> }) => props.set_items,
            refresh_post_process: () => storage_settings_post_process,
            initial_action: ({ form, props }: modal_type) => {
                form?.resetFields();
                props.set_connection_status?.("");
            },
        },
        {
            ...operation_status('edit_storage', 1, 'edit_storage'),
            width: 580,
            modal_message: storage_settings_msg,
            handle_ok: storage_ok,
            refresh_url: storage_settings_refresh_url,
            refresh_set_state: (props: { set_items: React.Dispatch<React.SetStateAction<table_list_type>> }) => props.set_items,
            refresh_post_process: () => storage_settings_post_process,
            initial_action: ({ props }: modal_type) => {
                props.set_connection_status?.("");
                // let item = props?.item_selected;
                // const intl = {
                //     storage_name: item?.storage_name,
                //     storage_type: item?.storage_type,
                //     description: item?.description,
                //     version: item?.storage_device.version,
                //     remote_path: item?.storage_device.remote_path,
                //     subscription_name: item?.subscription_name
                // };
                // form?.setFieldsValue(intl);
                // set_disabled(false);
            },
        },
        {
            // ...delete_operation('delete', 'storage_backup'),
            ...operation_status('delete_storage', 2, 'delete'),
            width: 600,
            modal_message: delete_storage_msg,
            handle_ok: ({ props }: modal_type) => {
                return {
                    key: "storage_backup",
                    url: `/backup/dbStorages/${props?.item_selected?.db_storage.id}`
                };
            },
            // refresh_url: storage_settings_refresh_url,
            // refresh_set_state: (props: { set_storage_settings_list: React.Dispatch<React.SetStateAction<table_list_type>> }) => props.set_storage_settings_list,
            // refresh_post_process: () => storage_settings_post_process
        },
        {
            ...operation_status('details', 1, 'details'),
            width: 580,
            modal_message: storage_settings_msg,
            footer: ({ props }: modal_type) => {
                return <Button type="primary" onClick={() => { props.set_visible?.(undefined) }}>OK</Button>
            }
        }
    ]
}